import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { completeForgotEmail } from '../server';
import * as Types from '../types';

export const useCompleteForgotEmail = ({
    token,
    setUserEmail
}: {
    token: string,
    setUserEmail: React.Dispatch<React.SetStateAction<string>>
}) => {
    const isMounted = useIsMounted();
    const getErrorMessage = useGetErrorMessage();
    const translate = useComponentTranslations();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async ({ data }: { data: Types.ICompleteForgotEmailFormData }): Promise<string | void> => {
        const { authenticationPIN } = data;

        try {
            const response = await completeForgotEmail({
                casinoName,
                pin: authenticationPIN,
                token
            });

            const { data: { email } = {} } = response;

            if (!email) {
                return translate('error');
            }

            isMounted() && setUserEmail(email);
        } catch (error) {
            return getErrorMessage(error);
        }
    }, [token, setUserEmail, casinoName, getErrorMessage, translate, isMounted]);
};
